module.exports = __webpack_public_path__ + "img/aboutus.7c8a2332.png";